import "choerodon-ui/lib/spin/style";
import _Spin from "@hzero-front-ui/c7n-ui/lib/Spin";
import "choerodon-ui/lib/timeline/style";
import _Timeline from "choerodon-ui/lib/timeline";
import "choerodon-ui/lib/row/style";
import _Row from "choerodon-ui/lib/row";
import "choerodon-ui/lib/col/style";
import _Col from "choerodon-ui/lib/col";
import "choerodon-ui/lib/icon/style";
import _Icon from "choerodon-ui/lib/icon";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import intl from "../../utils/intl";
import { getCurrentOrganizationId, getResponse } from "../../utils/utils";
import request from "../../utils/request";
import { getEnvConfig } from "../../utils/iocUtils";
import styles from "./index.less?modules";
var _getEnvConfig = getEnvConfig(),
  HZERO_FILE = _getEnvConfig.HZERO_FILE;
var AttachmentHistory = function AttachmentHistory(props) {
  var url = props.attachment.url;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    opList = _useState2[0],
    setOpList = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  useEffect(function () {
    if (url) {
      request("".concat(HZERO_FILE, "/v1/").concat(getCurrentOrganizationId(), "/file-op-logs"), {
        method: 'GET',
        headers: {
          'h-request-auto-decrypt': true
        },
        query: {
          fileUrlOrKey: url
        }
      }).then(function (res) {
        if (getResponse(res)) {
          setOpList(res.logs.content);
        }
      }).finally(function () {
        setLoading(false);
      });
    } else {
      setLoading(true);
    }
  }, [url]); // eslint-disable-next-line no-nested-ternary

  return opList.length > 0 ? /*#__PURE__*/React.createElement(_Timeline, null, opList.map(function (line) {
    return /*#__PURE__*/React.createElement(_Timeline.Item, {
      color: "#e8e8e8",
      className: styles['hzero-attachment-history-detail']
    }, /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, {
      span: 4,
      className: "history-detail-icon"
    }, /*#__PURE__*/React.createElement(_Icon, {
      type: line.opTypeCode === 'UPLOAD' ? 'file_upload' : 'get_app'
    })), /*#__PURE__*/React.createElement(_Col, {
      span: 20,
      className: "history-detail-item"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "realName"
    }, line.realName, "(", line.userName, ")"), /*#__PURE__*/React.createElement("span", null, line.opType)), /*#__PURE__*/React.createElement("div", null, line.tenantName), /*#__PURE__*/React.createElement("div", null, line.date))));
  })) : loading ? /*#__PURE__*/React.createElement(_Spin, {
    spinning: true
  }) : intl.get('hzero.common.components.noticeIcon.null').d('暂无数据');
};
export default AttachmentHistory;